export default "__VITE_ASSET__DkXDceJT__"